






























import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { BTabs, BTab } from 'bootstrap-vue';

import FactorsTab from './FactorsTab.vue';
import VectorsTab from './VectorsTab.vue';
import ScoresTab from './ScoresTab.vue';
import HeatmapTab from './HeatmapTab.vue';
import TasksTab from './TasksTab.vue';
import TasksWarningTab from './TasksWarningTab.vue';
import ContentTab from './ContentTab.vue';

import { Tab } from './tabs';

export default Vue.extend({
  name: 'RiskSettingsPage',
  components: {
    BTab,
    BTabs,
    FactorsTab,
    VectorsTab,
    ScoresTab,
    HeatmapTab,
    TasksTab,
    TasksWarningTab,
    ContentTab,
  },
  data() {
    return {
      tabs: [],
    };
  },
  computed: {
    ...mapGetters(['featureFlags']),
    activeTab(): number {
      return this.tabs.findIndex(tab => tab.route === this.$route.params.tab) || 0;
    },
  },
  created() {
    this.setPageTitle({ title: 'Risk settings' });

    let tasksComponent = this.featureFlags.extended_workflows ? 'tasks-warning' : 'tasks';

    this.tabs = [
      new Tab('factors', false),
      new Tab('vectors', false),
      new Tab('scores', false),
      new Tab('heatmap', false),
      new Tab(tasksComponent, false, 'Tasks', 'tasks'),
      new Tab('content', false),
    ];
  },
  methods: {
    ...mapActions({
      setPageTitle: 'setPageTitle',
    }),
    changeTab(tabIndex: number) {
      this.$router.replace({
        name: 'riskSettings',
        params: {
          tab: this.tabs[tabIndex].route,
        },
      });
    },
    setLoadDataOnTabs(tabNames: Array<string>) {
      this.tabs.forEach(tab => {
        if (tabNames.includes(tab.name)) {
          tab.loadData = true;
        }
      });
    },
  },
});
